import React from 'react';
import { Modal as AntModal} from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ModalTopBg } from '@styles';

const Modal = styled(AntModal)`

    .ant-modal-content {
        padding-top: 75px !important;
        text-align: center;
    }

    .ant-modal-title {
        text-align: center;
    }

    .ant-modal-footer {
        text-align: center;
    }
`;

const ConfirmModal = ({
    open,
    loading,
    onConfirm,
    handleClose,
}) => {
    const { t } = useTranslation()

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            open={open}
            width={320}
            title={t("common.confirm")}
            onCancel={handleClose}
            onOk={onConfirm}
            okText={t("common.confirm")}
            cancelText={t("common.cancel")}
            confirmLoading={loading}
        >
            <ModalTopBg />
            {t("wallet.fillAmountConfirmModalLabel")}
        </Modal>
    );
}

export default ConfirmModal;